/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Processed_AtInputs */

const vi_tea_purchase_processed_at = /** @type {(inputs: Tea_Purchase_Processed_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày thu hoạch`)
};

/**

* @param {Tea_Purchase_Processed_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_processed_at = /** @type {((inputs?: Tea_Purchase_Processed_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Processed_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_processed_at(inputs)
});